import { render, staticRenderFns } from "./PengawalanViewNew.vue?vue&type=template&id=2ef574aa&scoped=true&lang=pug&"
import script from "./PengawalanViewNew.vue?vue&type=script&lang=js&"
export * from "./PengawalanViewNew.vue?vue&type=script&lang=js&"
import style0 from "./PengawalanViewNew.vue?vue&type=style&index=0&id=2ef574aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef574aa",
  null
  
)

export default component.exports